import React, { Component } from "react";
import SlideAiDialog from "./SlideAiDialog";
import { AiIcon, SlideAiButton } from "../AiIcon";
import { ShowDialog, ShowDialogAsync } from "../../../react/components/Dialogs/BaseDialog";
import { Popup, PopupContainer, PopupContent, PopupPreview } from "../../../Components/Popup";
import { MenuItem } from "../../../Components/Menu";
import { Icon } from "../../../Components/Icon";
import { RegenerateImageDialog } from "../GenerateImage/RegenerateImageDialog";
import SlideAiController from "./SlideAiController";

export class SlideAIPopupButton extends Component {
    handleRegenerateSlide = () => {
        ShowDialog(SlideAiDialog, this.props);
    }

    handleRegenerateImage = async () => {
        const { currentSlide, currentTheme } = this.props;

        const metadata = currentSlide.getMetadata();
        const slideImage = metadata.generatedModel?.slideImage;
        const imageSource = metadata.imageSource ?? "ai";

        let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
            currentSlide,
            theme: currentTheme,
            prompt: slideImage?.prompt || "",
            imageSource: imageSource,
            imageStyle: slideImage?.imageStyle || "minimalist",
        });

        SlideAiController.regenerateSlideImage(imagePrompt, imageStyle);
    }

    render() {
        return (
            <Popup>
                <PopupPreview>
                    <AiIcon contained size={18} />
                </PopupPreview>
                <PopupContent>
                    {closePopup => (
                        <>
                            <MenuItem onClick={() => {
                                this.handleRegenerateSlide();
                                closePopup();
                            }}>
                                <Icon>change_circle</Icon>Generate Ideas...
                            </MenuItem>
                            <MenuItem onClick={() => {
                                this.handleRegenerateImage();
                                closePopup();
                            }}>
                                <Icon>photo</Icon>Regenerate Image...
                            </MenuItem>
                        </>
                    )}
                </PopupContent>
            </Popup>
        );
    }
}

